import { clsx } from "clsx";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  align?: "start" | "center" | "end";
  className?: string;
};

export function TableCell({ children, align = "start", className }: Props) {
  return (
    <div role="gridcell" className="nuco-table__cell">
      <div
        className={clsx(
          "nuco-table__cell-inner",
          `nuco-table__cell-inner--align-${align}`,
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}
